import { Component, OnInit, ViewEncapsulation, Renderer2 } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';
import { Notice } from '../../models/notice';
import { NoticesService } from '../../services/notices.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { ActivatedRoute } from '@angular/router';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { pages } from '../../../../../utils/pages';

@Component({
  selector: 'app-notices',
  templateUrl: './notices.component.html',
  styleUrls: ['./notices.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NoticesComponent extends ComponentBase implements OnInit {

  subscription: Subscription;
  notices: Array<Notice> = [];
  noticeId: number;
  loading: boolean = true;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(private pageHeadingService: PageHeadingService
    , private noticesServices: NoticesService
    , private route: ActivatedRoute
    , private routingService: RoutingService
    , private renderer: Renderer2) {
    super();
  }

  ngOnInit() {
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Announcements"));
    this.subscription = combineLatest(this.noticesServices.getNotices(), this.route.params)
      .subscribe(([notices, params]) => {
        this.loading = false;
        this.notices = notices;
        let id = +params['id'];
        if (!id && this.notices.length) {
          let route = new PrifactRoute();
          route.primary_command = ['pages', 'notices', this.notices[0].announcement_id];
          route.replace_url = true;
          this.routingService.navigate(route);
        }
        else if (id) {
          this.noticeId = this.notices.find(o => o.announcement_id == id).announcement_id;
        }
      });
    this.addSubscription(this.subscription);
  }

  noticeClicked(id: number) {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'notices', id];
    route.replace_url = true;
    route.append_current_url_to_history = true;
    route.page_name = pages.announcementDetails;
    this.routingService.navigate(route);
    this.renderer.addClass(document.body, 'second-page');
  }

}
